import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-88210d5e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "banner",
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "justify-content": "space-between"
  }
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "name-box"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 了解更多 >", -1));

const _hoisted_5 = {
  key: 0,
  class: "look-detail"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productBarList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "inner-box",
      style: _normalizeStyle({
        background: `url(${_ctx.imgUrl(item.fileUrl)}) no-repeat center center/cover`
      }),
      onClick: $event => _ctx.goProduct(item)
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1), _hoisted_4], 12, _hoisted_2);
  }), 256))]), _ctx.productBarList.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.router.push({
      path: '/columnDisplay',
      query: {
        partCode: _ctx.productBarList[0].partCode
      }
    }))
  }, "查看更多 >")])) : _createCommentVNode("", true)]);
}